<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary" flat>
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Receive</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container>
        <div class="flex flex-col">
          <div class="flex space-x-2.5">
            <div class="flex flex-col space-y-2.5" style="max-width: 400px;">
              <div>
                <v-card class="ma-0 pa-2" outlined flat>
                  <div class="flex flex-col space-y-2.5" style="max-width: 400px">
                    <v-text-field readonly label="Receipt No" outlined dense hide-details
                      :value="storeTransfer.receipt_no"></v-text-field>
                    <v-text-field readonly label="Order No" outlined dense hide-details
                      :value="storeTransfer.order_no"></v-text-field>
                    <v-text-field readonly type="date" label="Date" outlined dense hide-details
                      :value="storeTransfer.date"></v-text-field>
                    <v-text-field readonly label="Notes" outlined dense hide-details
                      :value="storeTransfer.notes"></v-text-field>
                    <v-text-field label="Received By" outlined dense hide-details v-model="receivedBy"></v-text-field>
                    <div>
                      <v-select v-model="storeTransferStatus" label="Completed" hide-details class="ma-0"
                        :items="['pending', 'out for delivery', 'partially delivered', 'completed', 'cancelled']"
                        outlined dense></v-select>
                    </div>
                    <v-btn :loading="savingData" dark color="green" elevation="0" @click="save">Save</v-btn>
                  </div>
                </v-card>
              </div>
              <div>
                <v-card class="ma-0 pa-2" outlined flat>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete label="Stock Code" hide-details="auto" outlined :items="splrPdList"
                        :search-input.sync='searchInput' :loading='splrPdLoading' dense item-value='stock_code'
                        no-filter @change="stockCodeChange" return-object v-model="selectedStock">
                        <template v-slot:selection="{ item }">
                          <span>{{ item.supplier_id }}-{{ item.stock_code
                          }}
                          </span>
                          <span class="blue-grey--text mx-1 text-caption">{{ item.product_name }} ({{
                            item.brand_name
                          }})
                          </span>
                        </template>
                        <template v-slot:item="{ item }">
                          <span class="blue--text">
                            {{ item.supplier_id }}: {{
                              item.stock_code }}
                          </span>
                          <span class="mx-1"></span>
                          <small>{{ item.product_name }} ({{
                            item.brand_name
                          }})</small>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field label="SRP" prefix="₱" type="number" outlined dense hide-details="auto"
                        v-model.number="retail"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field type="number" outlined dense hide-details="auto" v-model.number="quantity">
                        <template v-slot:label>
                          <span>Quantity</span>
                          <span class="mx-1"></span>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete :items="units" label="unit" outlined dense hide-details="auto"
                        @change="onUnitChange" v-model="unit">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea label="Notes" auto-grow="auto-grow" no-resize="no-resize" outlined hide-details="auto"
                        dense rows="1" v-model="notes"></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-btn color="green" block @click="addItem">Add Item</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </div>
            <div class="flex-1">
              <v-card class="ma-0" flat outlined>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Code</th>
                      <th>Product</th>
                      <th>Unit</th>
                      <th>Qty</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in items" :key="item.from_stock_id">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.from_stock.stock_code }}</td>
                      <td>
                        {{ item.from_stock.product_name }}
                      </td>
                      <td>
                        {{ item.unit }}
                      </td>
                      <td>
                        <span @click="updateQuantity(item)">
                          {{ item.quantity }}
                        </span>
                        <!-- <v-text-field dense x-small hide-details outlined type="number" style="min-width: 0;"
                          v-model="item.quantity" /> -->
                      </td>
                      <td>
                        <v-select dense outlined style="text-align: center;" hide-details @change="storeToLocal"
                          :items="storeTransferItemStatus" v-model="item.status">
                        </v-select>
                      </td>
                      <td style="width: 200px;">
                        <div class="flex">
                          <v-btn v-if="!item.id" text color="red" small @click="removeItem(item)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </div>
          </div>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from '@/extra-functions/axios.extra'
import { mapState } from 'vuex'
import splrPdRepository from '@/repositories/supplier-product.repository'
import { useWatchEffect, useDebounce, dynamicUnit, Swal } from '../../../../lib/utils'
import LocalStore from '../../../../lib/localStore'

const [watchEffect, clearWatchEffect] = useWatchEffect()
const searchInputDebounce = useDebounce()

const itemVars = () => {
  return {
    fromStockId: null,
    retail: null,
    quantity: null,
    notes: null,
    unit: '',
  }
}
const localStore = new LocalStore()

export default {
  name: 'ViewReceiveTransferInventory',
  data() {
    return {
      dialog: false,
      gettingData: false,
      storeTransfer: {},
      storeTransferId: null,
      storeTransferItemStatus: ['pending', 'completed', 'cancelled'],
      savingData: false,
      storeTransferStatus: null,
      receivedBy: null,
      splrPdLoading: false,
      splrPdList: [],
      stockInCart: new Set(),
      selectedStock: null,
      items: [],
      ...itemVars(),
      searchInput: '',
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      units: state => state.unit.allList.map(unit => unit.unit),
    }),
  },
  watch: {
    searchInput() {
      watchEffect((onCleanup) => {
        const controller = new AbortController()
        onCleanup(() => {
          controller.abort()
        })
        searchInputDebounce(() => {
          this.getSplrPd(controller)
        })
      }, 'watchSearchInput')
    },
  },
  destroyed() {
    clearWatchEffect()
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.storeTransferId = null
      this.storeTransfer = {}
    },
    openDialog(storeTransferId) {
      this.dialog = true
      watchEffect(async (onCleanup) => {
        const getSplrPdController = new AbortController()
        const getTransferInventoryController = new AbortController()
        onCleanup(() => {
          getTransferInventoryController.abort()
          getSplrPdController.abort()
        })
        await this.getTransferInventory(storeTransferId, getTransferInventoryController)
        this.getLocalData()
        this.getSplrPd(getSplrPdController)
      }, 'onOpenDialog')
      this.storeTransferId = storeTransferId
    },
    addItem() {
      try {
        if (!this.fromStockId) return
        if (this.stockInCart.has(this.fromStockId)) {
          this.items = this.items.map(item => {
            if (item.from_stock_id !== this.fromStockId) return item
            return {
              ...item,
              quantity: item.quantity + Number(this.quantity),
            }
          })
          this.resetItem()
          this.storeToLocal()
          return
        }
        this.items = [
          ...this.items,
          {
            from_stock_id: this.fromStockId,
            retail: this.retail,
            quantity: Number(this.quantity),
            notes: this.notes,
            from_stock: { ...this.selectedStock },
            unit: this.unit,
            status: 'completed',
          },
        ]
        this.stockInCart.add(this.fromStockId)
        this.resetItem()
        this.storeToLocal()
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong')
      }
    },

    resetItem() {
      const defaultVars = itemVars()
      Object.keys(defaultVars).forEach(key => {
        this[key] = defaultVars[key]
      })
      this.selectedStock = {}
    },

    async getTransferInventory(storeTransferId, controller) {
      try {
        if (this.gettingData) return
        this.gettingData = true
        const { data } = await axios(this.token).get(`/store-receives/${storeTransferId}/show`, { signal: controller?.signal })
        this.storeTransfer = data
        this.storeTransferStatus = data.status
        this.receivedBy = data.received_by
        this.items = data.items.map(item => {
          this.stockInCart.add(item.from_stock_id)
          return {
            id: item.id,
            from_stock_id: item.from_stock_id,
            from_stock: item.from_stock,
            quantity: item.quantity,
            status: item.status,
            unit: item.unit,
          }
        })
      } catch (e) {
        console.error(e)
        this.$alertSwalError('oops something went wrong try to re-open to refresh')
      } finally {
        this.gettingData = false
      }
    },

    async save() {
      try {
        if (this.savingData) return
        this.savingData = true
        const items = this.items.reduce((prev, next) => {
          prev[next.id] = {
            status: next.status,
            quantity: Number(next.quantity),
          }
          return prev
        }, {})
        const newItems = this.items.reduce((prev, next) => {
          if (next.id) return prev
          const data = {
            from_stock_id: next.from_stock_id,
            retail: next.retail,
            quantity: next.quantity,
            notes: next.notes,
            status: next.status,
          }
          prev[next.from_stock_id] = data
          return prev
        }, {})
        const data = {
          status: this.storeTransferStatus,
          received_by: this.receivedBy,
          items,
          new_items: newItems,
        }
        const res = await axios(this.token).put(`/store-receives/${this.storeTransferId}/update-status`, data)
        this.$emit('save-success')
        this.getTransferInventory(this.storeTransferId)
        this.$alertSwalSuccess('successfully saved')
        this.removeFromLocal()
      } catch (e) {
        console.error(e)
        if (e?.response?.status === 422) {
          const { data } = e.response
          console.error(data)
          return
        }
        this.$alertSwalError('oops something went')
      } finally {
        this.savingData = false
      }
    },

    /**
     * Description
     * @param {AbortController} [controller]
     */
    async getSplrPd(controller = null) {
      try {
        this.splrPdLoading = true
        const { from_store: fromStore } = this.storeTransfer || {}
        if (!fromStore) throw new Error('fromStore undefined line 315 on ViewReceiveTransferInventory.vue')
        const { data } = await splrPdRepository.paginate(fromStore.id, { search: this.searchInput }, controller)

        this.splrPdList = data.map(e => {
          const qSpent = e.consumer_loan_inventories_quantity + e.lost_inventories_quantity + e.sale_inventories_quantity
          const qRemaining = (e.recieved_inventories_quantity + e.stock_trans_in) - (qSpent + e.stock_trans_out)
          return {
            ...e,
            qRemaining,
          }
        })
      } catch (e) {
        console.error(e.message)
        this.$alertSwalError('oops something went wrong!')
      } finally {
        this.splrPdLoading = false
      }
    },
    removeItem({ from_stock_id: fromStockId }) {
      this.stockInCart.delete(fromStockId)
      this.items = this.items.filter(item => item.from_stock_id !== fromStockId)
    },
    stockCodeChange(stock) {
      this.unit = stock.unit
      this.fromStockId = stock.stock_id
      this.retail = stock.retail
      this.quantity = 1
    },
    getLocalData() {
      const viewReceiveTransferInventoryLocalData = localStore.get('viewReceiveTransferInventory')
      const data = viewReceiveTransferInventoryLocalData?.[this.storeTransferId] ?? null
      if (!data) return
      Object.keys(itemVars()).forEach(key => {
        this[key] = data[key]
      })
      this.items = [...data.items]
    },
    storeToLocal() {
      if (this.isEdit) return
      const inputs = Object.keys(itemVars()).reduce((prev, next) => {
        prev[next] = this[next]
        return prev
      }, {})
      const localData = localStore.get('viewReceiveTransferInventory')
      const data = {
        ...localData,
        [this.storeTransferId]: {
          ...inputs,
          items: [...this.items],
          unsavedChanges: true,
        },
      }
      localStore.set({
        viewReceiveTransferInventory: data,
      })
      this.$store.dispatch('appDrawer/setReceiveUnsavedChanges', Object.keys(data))
    },
    removeFromLocal() {
      const localData = localStore.get('viewReceiveTransferInventory')
      if (!localData) return
      const localKeys = Object.keys(localData).filter(key => key !== this.storeTransferId)
      const data = localKeys.reduce((prev, next) => {
        prev[next] = localData[next]
      }, {})
      localStore.set({
        viewReceiveTransferInventory: data,
      })
      const dataKeys = Object.keys(data ?? {})
      this.$store.dispatch('appDrawer/setReceiveUnsavedChanges', dataKeys.length)
    },
    onUnitChange(unit) {
      const stock = this.selectedStock
      const quantityPerUnit = dynamicUnit(unit, 1)
      this.retail = quantityPerUnit * stock.retail
    },
    async updateQuantity(item) {
      const quantity = prompt('Quantity', item.quantity)
      if (quantity === null) return
      item.quantity = Number(quantity)
    },
  },
}
</script>
